import './App.css';
import './Animacion.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { Routes, Route } from 'react-router-dom';
import { Footer, Header, NavExtend, ScrollToTop, WppFlotante } from './componentes/Principales';
import { Home } from './pages/Home';
import { Contacto } from './pages/Contacto';
import { NotFound } from './pages/NotFound';
import { MiComponente } from './componentes/Example';
import { Servicios } from './pages/Servicios';
import { FAQs } from './pages/FAQ';
import { Nosotros } from './pages/Nosotros';

function App() {
  return (
    <div className="App m_bg_f2f2f2 m-0 p-0">
      <ScrollToTop />
      <MiComponente />
      <NavExtend />
      <WppFlotante />
      {/* <Header /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQs />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <MiComponente />
    </div>
  );
}

export default App;
